export default __webpack_public_path__ + "static/academicproduct-24b654d1f26edff62d0867ac2454653d.png";